<template>
    <div>

        <div class="border-bottom">
            <div class="container-narrow">
                <div class="padding-v-2 flex justify-between">

                    <div>
                        <slot name="heading"></slot>
                        <slot name="locations"></slot>
                    </div>

                    <div v-if="!formMode">
                        <button class="btn-primary" type="button" @click="openForm">Apply for this job</button>
                    </div>

                </div>
            </div>
        </div>

        <div class="border-bottom" v-if="!formMode">
            <div class="container-narrow">
                <slot name="content"></slot>
            </div>
        </div>

        <div class="container-narrow" v-if="!formMode">
            <div class="padding-v-5">
                <button class="btn-primary" type="button" @click="openForm">Apply for this job</button>
            </div>
        </div>

        <div class="container-narrow" v-if="formMode">
            <div id="vacancy-form" class="padding-v-5">
                <h4 class="margin-b-2">Apply for this job</h4>
                <p class="text-m text-color-weak margin-b-4">Please submit a detailed CV and fill out all the fields in
                    the form.</p>

                <div class="flex row text-l margin-t-2 align-center gap-1 success-badge" v-if="success">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 12.75L11.25 15L15 9.75M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
                            stroke="#183147" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Your Application was submitted.
                </div>
                <div v-if="!success">
                    <template v-for="field in formFields">
                        <component :is="mapFieldTypes(field)" :field="field"></component>
                    </template>

                    <slot name="complience_content"></slot>

                    <template v-for="field in complienceFields">
                        <component :is="mapFieldTypes(field)" :field="field"></component>
                    </template>

                    <p class="margin-t-2">By registering your information, you confirm that you agree to the processing of
                        your personal data by Netcracker as described in the Privacy Notice.</p>
                    <div class="margin-t-2">
                        <button class="btn-primary" type="submit" @click="submitForm">Submit Application</button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script setup>
import {ref, onBeforeMount, onMounted} from 'vue';
import InputTextComponent from "./form/InputTextComponent.vue";
import InputFileComponent from "./form/InputFileComponent.vue";
import MultiValueSingleSelectComponent from "./form/MultiValueSingleSelectComponent.vue";

const formMode = ref(false);
const formFields = ref([]);
const complienceFields = ref([]);

const success = ref(false);

const props = defineProps({
    formConfig: {
        type: Array,
        default: []
    },
    complienceConfig: {
        type: Array,
        default: []
    },
    jobId: {
        type: Number,
        default: null
    }
})

const mapFieldTypes = (field) => {
    if (field.type === 'input_text') return InputTextComponent;
    if (field.type === 'input_file') return InputFileComponent;
    if (field.type === 'multi_value_single_select') return MultiValueSingleSelectComponent;
}

const openForm = () => {
    formMode.value = true;
    window.scrollTo(0, 0);
}

const submitForm = async () => {
    const formData = new FormData();
    let formValid = true;

    formFields.value.forEach((field) => {
        if (isValid(field)) {
            field.isValid = true;
            if (field.type === 'input_file') {
                formData.append(field.name, field.value[0]);
            }
            formData.append(field.name, field.value);
        } else {
            field.isValid = false;
            formValid = false;
        }

    })
    complienceFields.value.forEach((field) => {
        if (isValid(field)) {
            field.isValid = true;
            formData.append(field.name, field.value);
        } else {
            field.isValid = false;
            formValid = false;
        }
    })

    if (formValid) {
        success.value = true;

        await fetch(`/api/submit-application/${props.jobId}`, {
            method: "POST",
            body: formData,
        });
    }
    scrollToFormStart();
}

const isValid = (field) => {
    if (!field.required) return true;
    if (field.type === 'input_file') return field.value.length > 0;

    return field.value && field.value !== '';
}

const scrollToFormStart = () => {
    const el = document.getElementById('vacancy-form');
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

onBeforeMount(() => {
    props.formConfig.forEach((field) => {
        formFields.value.push({
            name: field.name,
            label: field.label,
            type: field.type,
            description: field.description,
            required: field.required,
            isValid: true,
            value: ''
        })
    })

    props.complienceConfig.forEach((field) => {
        complienceFields.value.push({
            name: field.name,
            label: field.label,
            type: field.type,
            values: field.values,
            required: field.required,
            isValid: true,
            value: ''
        })
    })
});

</script>
